export enum ApiKeysPermissions {
  ADD = 'ADD_API_KEYS',
  DELETE = 'DELETE_API_KEYS',
  UPDATE = 'UPDATE_API_KEYS',
  VIEW = 'VIEW_API_KEYS',
}
